import React, { useRef } from "react";
import CountUp from "react-countup";
import { useInView } from "framer-motion";
import { FiBarChart2 } from "react-icons/fi";
import { useHomeContext } from "../../../context/Home_context";
import "./HomeStatistics.css";

const parseStatValue = (str = "") => {
  const match = String(str).match(/^(\d[\d,]*)/);
  const numeric = match ? parseInt(match[1].replace(/,/g, ""), 10) || 0 : 0;
  const suffix = match ? String(str).slice(match[1].length).trim() : String(str);
  return { numeric, suffix };
};

const HomeStatistics = () => {
  const { current_expo_data } = useHomeContext();
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { amount: 0.15, once: true });

  const stats = (current_expo_data?.statistics || []).filter(
    (item) => Number(item?.status) === 1
  );

  return (
    <section className="ss-strip" ref={sectionRef}>
      <div className="ss-inner">
        {stats.length === 0 ? (
          <div className="ss-no-data-wrapper">
            <div className="ss-no-data-icon">
              <FiBarChart2 />
            </div>
            <div className="ss-no-data-text">
              <h4>No Statistics Available</h4>
              <p>Key highlights and statistics will be published soon.</p>
            </div>
          </div>
        ) : (
          <div className={`ss-row${isInView ? " ss-row--in-view" : ""}`}>
            {stats.map((item, i) => {
              const stat = parseStatValue(item.value);

              return (
                <div className="ss-item" key={item.id || i}>
                  <div className="ss-text">
                    <span className="ss-value notranslate" translate="no">
                      {isInView ? (
                        <CountUp
                          end={stat.numeric}
                          duration={1.3}
                          separator=","
                          suffix={stat.suffix}
                        />
                      ) : (
                        `0${stat.suffix}`
                      )}
                    </span>
                    <span className="ss-label">{item.name}</span>
                  </div>
                  <span className="ss-dot" />
                </div>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
};

export default HomeStatistics;
